import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor;
import api from 'core/util/api';
import { action, observable } from 'mobx';
let UdeStore = (_class = class UdeStore {
  constructor() {
    _initializerDefineProperty(this, "flowVariant", _descriptor, this);
    this.ude = {
      id: '',
      name: '',
      description: '',
      createdAt: '',
      updatedAt: ''
    };
    this.pendingQuery = null;
  }
  setFlowVariant(variant) {
    this.flowVariant = variant;
  }
  runQuery(query) {
    return api.post('/api/ui/ude/query', {
      data: {
        query
      }
    });
  }

  /** Stash a query + chart settings for navigation to the UDE page. */
  setPendingQuery(pending) {
    this.pendingQuery = pending;
  }

  /** One-shot read of the stashed pending query. Returns and clears it. */
  consumePendingQuery() {
    const pending = this.pendingQuery;
    this.pendingQuery = null;
    return pending;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "flowVariant", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'a';
  }
}), _applyDecoratedDescriptor(_class.prototype, "setFlowVariant", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setFlowVariant"), _class.prototype), _class);
export default new UdeStore();